import { gql } from 'graphql-tag';
import { getRegisteredExperiments } from './register-experiment';
const queries = {
    GET_EXPERIMENTS: gql `
    query Experiments($experimentNames: [String]) {
      viewer {
        id
        featureSwitchesExperiments(names: $experimentNames) {
          collection {
            name
            variant
          }
        }
      }
    }
  `,
};
export const splitkitHubModule = {
    name: 'splitkitHubModule',
    queries,
    initialize: async ({ client, broadcastError }) => {
        var _a, _b;
        const registeredExperiments = getRegisteredExperiments();
        if (registeredExperiments.length > 0) {
            // initialising with NOT FOUND
            let experiments = registeredExperiments.reduce((index, next) => {
                index[next.name] = { ...next, status: 404 };
                return index;
            }, {});
            try {
                const result = await (client === null || client === void 0 ? void 0 : client.query({
                    query: queries.GET_EXPERIMENTS,
                    variables: {
                        experimentNames: registeredExperiments.map((ex) => ex.name),
                    },
                }));
                const { error, data } = result;
                if (error) {
                    Object.values(experiments).forEach((exp) => (exp.status = 500));
                    broadcastError(error, 'The GET_EXPERIMENTS query call has returned an error!');
                }
                const rawExperiments = (_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.featureSwitchesExperiments.collection) !== null && _b !== void 0 ? _b : [];
                for (const rawExp of rawExperiments) {
                    experiments[rawExp.name] = {
                        ...experiments[rawExp.name],
                        status: 200,
                        variant: rawExp.variant,
                    };
                }
                return {
                    data: { experiments },
                    meta: {
                        experimentsQueryError: error,
                    },
                };
            }
            catch (error) {
                Object.values(experiments).forEach((exp) => (exp.status = 500));
                broadcastError(error, 'The GET_EXPERIMENTS query call has failed!');
                return {
                    data: {
                        experiments,
                    },
                    meta: {
                        experimentsQueryError: error,
                    },
                };
            }
        }
        return {
            data: {
                experiments: {},
            },
            meta: {
                experimentsQueryError: null,
            },
        };
    },
    getHooks: (useFrameHooks) => {
        const useExperiment = (name) => {
            var _a, _b, _c;
            const { useFrameContext } = useFrameHooks();
            const context = useFrameContext();
            if (context.experimentsQueryError) {
                return 'A';
            }
            // A is alsways the default and fallback if something goes wrong
            return (_c = (_b = (_a = context.experiments) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b.variant) !== null && _c !== void 0 ? _c : 'A';
        };
        const useExperimentTrackingData = () => {
            const { useFrameContext } = useFrameHooks();
            const context = useFrameContext();
            if (context.experiments &&
                Object.values(context.experiments).length > 0) {
                const runningExperiments = Object.values(context.experiments);
                let propExperiment = [];
                let propExperimentInfo = [];
                for (const experiment of runningExperiments) {
                    const displayed = experiment.status === 200 ? experiment.variant : 'A';
                    const received = experiment.status === 200 ? experiment.variant : '0';
                    // data means
                    // - name of the experiment
                    // - which variant was displayed (A if something went wrong)
                    // - which variant was reported by the backend (0 if something went wrong)
                    propExperiment.push(`${experiment.name}|${displayed}|${received}`);
                    // data means
                    // - name of the experiment
                    // - status: 200 = OK, 404 = experiment not found, 500 = error during request
                    // - user type: U = logged in, V = logged out (not supported)
                    propExperimentInfo.push(`${experiment.name}|${experiment.status}|U`);
                }
                return {
                    PropExperiment: propExperiment.join(','),
                    PropExperimentInfo: propExperimentInfo.join(','),
                };
            }
            else {
                return {};
            }
        };
        return { useExperiment, useExperimentTrackingData };
    },
};
//# sourceMappingURL=splitkit-hub-module.js.map